import React from 'react'
import PropTypes from 'prop-types'

import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

const Title = ({
  handleSideFilterMenuCollapseChange,
  sideFilterVisible,
  translate,
}) => (
  <Row>
    {sideFilterVisible && (
      <Col xs={3}>
        <h4 className='padding-left'>
          {translate('localUsers.editForm.register')}
        </h4>
      </Col>
    )}

    <Col xs={sideFilterVisible ? 9 : 12} className='padding-top'>
      <button
        className={`filter-button title ${
          sideFilterVisible ? '' : 'margin-left'
        }`}
        onClick={() => handleSideFilterMenuCollapseChange(!sideFilterVisible)}
      >
        <i
          className={`glyph glyph-grey glyph-${
            sideFilterVisible ? 'double-arrow-left' : 'double-arrow-right'
          } icon-size`}
        />
        {translate(
          sideFilterVisible
            ? 'localUsers.editForm.list'
            : 'localUsers.editForm.register'
        )}
      </button>
    </Col>
  </Row>
)

Title.propTypes = {
  handleSideFilterMenuCollapseChange: PropTypes.func.isRequired,
  sideFilterVisible: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Title
